import APPCONFIG from '../../constants/Config';
import {
  GET_INSTALLATION_LF,
  GET_INSTALLATION_LF_SUCCESS,
  GET_INSTALLATION_CUSTOMER_LF,
  GET_INSTALLATION_CUSTOMER_LF_SUCCESS,
  GET_DEVICE_LF,
  GET_DEVICE_LF_SUCCESS,
  GET_SIMCARD_LF,
  GET_SIMCARD_LF_SUCCESS,
  GET_DISTRIBUTION_LF,
  GET_DISTRIBUTION_LF_SUCCESS,
  GET_PROFILE_LF,
  GET_PROFILE_LF_SUCCESS,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeInstallation } from '../../models/installation';
import { deserialize as deserializeDevice } from '../../models/device';
import { deserialize as deserializeCustomer } from '../../models/customer';
import { deserialize as deserializeSimcard } from '../../models/simcard';
import { deserialize as deserializeDistribution } from '../../models/distribution';
import { deserialize as deserializeProfile } from '../../models/profile';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.listFilter;
const listFilter = (state = initialSettings, action) => {
  switch (action.type) {
    case GET_INSTALLATION_LF:
      return {
        ...state,
        installation: {
          ...state.installation,
          loading: true,
          data: null,
        },
      };
    case GET_INSTALLATION_LF_SUCCESS:
      return {
        ...state,
        installation: {
          ...state.installation,
          loading: false,
          data: deserializeInstallation(action.data.data),
        },
      };
    case GET_INSTALLATION_CUSTOMER_LF:
      return {
        ...state,
        customer: {
          ...state.customer,
          loading: true,
          data: null,
        },
      };
    case GET_INSTALLATION_CUSTOMER_LF_SUCCESS:
      return {
        ...state,
        customer: {
          ...state.customer,
          loading: false,
          data: deserializeCustomer(action.data.data),
        },
      };
    case GET_DEVICE_LF:
      return {
        ...state,
        device: {
          ...state.device,
          loading: true,
          data: null,
        },
      };
    case GET_DEVICE_LF_SUCCESS:
      return {
        ...state,
        device: {
          ...state.device,
          loading: false,
          data: deserializeDevice(action.data.data),
        },
      };
    case GET_SIMCARD_LF:
      return {
        ...state,
        simcard: {
          ...state.simcard,
          loading: true,
          data: null,
        },
      };
    case GET_SIMCARD_LF_SUCCESS:
      return {
        ...state,
        simcard: {
          ...state.simcard,
          loading: false,
          data: deserializeSimcard(action.data.data),
        },
      };
    case GET_DISTRIBUTION_LF:
      return {
        ...state,
        distribution: {
          ...state.distribution,
          loading: true,
          data: null,
        },
      };
    case GET_DISTRIBUTION_LF_SUCCESS:
      return {
        ...state,
        distribution: {
          ...state.distribution,
          loading: false,
          data: deserializeDistribution(action.data.data),
        },
      };
    case GET_PROFILE_LF:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: true,
          data: null,
        },
      };
    case GET_PROFILE_LF_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          loading: false,
          data: deserializeProfile(action.data.data),
        },
      };
    default:
      return state;
  }
};

export default listFilter;



// WEBPACK FOOTER //
// ./reducers/listFilter/listFilter.js